import KPIDropdown from './KPIDropdown';

export default KPIDropdown;
